import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as GreenCheckmarkIcon } from 'assets/icons/GreenCheckmark.svg';
import { ReactComponent as ValidationFailIcon } from 'assets/icons/ValidationFail.svg';
import { ReactComponent as ValidationPendingIcon } from 'assets/icons/ValidationPending.svg';

import { FaceValidationStatus, FaceValidationResult, FACE_VALIDATION_KEYS, FaceValidationKey } from './types';
import { useStyles } from './styles';

interface IFaceValidationOverlayProps {
  validationResults: FaceValidationResult;
}

const TRANSLATION_KEY_MAP: Record<FaceValidationKey, string> = {
  faceCentered: 'capturePhoto.faceValidation.faceCentered',
  headStraight: 'capturePhoto.faceValidation.headStraight',
  goodLighting: 'capturePhoto.faceValidation.goodLighting',
  clearNoBlur: 'capturePhoto.faceValidation.clearNoBlur',
  eyesVisible: 'capturePhoto.faceValidation.eyesVisible',
  faceClearlyVisible: 'capturePhoto.faceValidation.faceClearlyVisible',
  singleFaceDetected: 'capturePhoto.faceValidation.singleFaceDetected',
  correctDistance: 'capturePhoto.faceValidation.correctDistance',
};

const StatusIcon = ({ status }: { status: FaceValidationStatus }) => {
  switch (status) {
    case FaceValidationStatus.PASS:
      return <GreenCheckmarkIcon />;
    case FaceValidationStatus.FAIL:
      return <ValidationFailIcon />;
    case FaceValidationStatus.PENDING:
      return <ValidationPendingIcon />;
  }
};

const FaceValidationOverlay = ({ validationResults }: IFaceValidationOverlayProps) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.faceValidationOverlay}>
      {FACE_VALIDATION_KEYS.map(key => (
        <div key={key} className={classes.faceValidationItem}>
          <StatusIcon status={validationResults[key]} />
          <span className={classes.faceValidationLabel}>{t(TRANSLATION_KEY_MAP[key])}</span>
        </div>
      ))}
    </div>
  );
};

export default memo(FaceValidationOverlay);
